import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    address,
    lastTime,
    taxCalculationPeriod,
  },
} = checkout;

const validation = Yup.object().shape({
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  [lastTime.name]: Yup.string().required(lastTime.errorMsg),
  [taxCalculationPeriod.name]: Yup.string().required(taxCalculationPeriod.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
